import { envName } from "@faire/web/common/user-agent/envName";

export const isProduction = (): boolean => envName() === "production";
